import Immutable from 'immutable';
import {
  FLAG_GETTING_DELIVERY_GROUPS,
  GET_DELIVERY_GROUPS,
  CLEAR_DELIVERY_GROUPS,
  FLAG_DELIVERY_GROUP_ACTIVITY,
  CLEAR_DELIVERY_GROUP,
  GET_DELIVERY_GROUP,
} from '../../../actions/types/cargo';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_DELIVERY_GROUPS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_DELIVERY_GROUPS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_DELIVERY_GROUPS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_DELIVERY_GROUP_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_DELIVERY_GROUP:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_DELIVERY_GROUP:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
